import { render, staticRenderFns } from "./ShelfApp.vue?vue&type=template&id=79cecdf8&"
import script from "./ShelfApp.vue?vue&type=script&lang=js&"
export * from "./ShelfApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports